import { CodeError } from '@iotize/common/error';

export class IoTizeStudioError extends CodeError<IoTizeStudioError.Code> {
  static invalidKeyValue(key: string, msg: string) {
    return new IoTizeStudioError(
      `Invalid IoTize studio value for configuration key "${key}". ${msg}`,
      IoTizeStudioError.Code.InvalidConfigKeyValue,
    );
  }
}

export namespace IoTizeStudioError {
  export enum Code {
    InvalidConfigKeyValue = 'IoTizeStudioErrorInvalidConfigKeyValue',
  }
}
